import { useState } from "react";
import { ArrowRight } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/shared/components/ui/dialog";
import PostLossPaywall from "@/pages/postloss/components/PostLossPaywall";
import { usePaymentTier } from "@/shared/hooks/usePaymentTier";
import { useAppContext } from "@/shared/hooks/useAppContext";
import checklistImage from "@/shared/assets/illustrations/checklist.svg";

interface FullDiscoveryUpgradeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function FullDiscoveryUpgradeDialog({
  open,
  onOpenChange,
}: FullDiscoveryUpgradeDialogProps) {
  const [paywallOpen, setPaywallOpen] = useState(false);
  const { person } = useAppContext();
  const { tier } = usePaymentTier(person?.estate_id);

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent size="sm" className="flex flex-col items-center text-center">
          <DialogHeader className="w-full">
            <DialogTitle className="sr-only">Upgrade</DialogTitle>
          </DialogHeader>
          <img
            src={checklistImage}
            alt="Estate Setup checklist"
            className="h-[150px] w-auto object-contain -mt-6"
          />
          <div className="flex flex-col gap-2">
            <h4>Get Estate Setup for the steps ahead</h4>
            <p className="text-secondary">
              Get a personalized roadmap, an estimated estate inventory, and pre-filled probate
              forms so you can organize and file with confidence.
            </p>
          </div>
          <Button
            variant="brand"
            rounded
            className="w-full gap-2"
            onClick={() => {
              onOpenChange(false);
              setPaywallOpen(true);
            }}
          >
            Upgrade
            <ArrowRight className="h-4 w-4" />
          </Button>
          <p className="text-sm text-secondary">Trusted by over 1,000 families navigating loss</p>
        </DialogContent>
      </Dialog>

      <PostLossPaywall
        isOpen={paywallOpen}
        onOpenChange={setPaywallOpen}
        promptLocation="full_discovery"
        currentTier={tier}
      />
    </>
  );
}
